import { Injectable } from '@angular/core';
import { OrganizationService } from '../http/agency-mgmt/organization.service';
import { JobCacheService } from 'src/app/job/services/job-detail/job-cache.service';

@Injectable({
  providedIn: 'root'
})
export class CacheStorageService {

  private _isPalaceEnable = false;

  constructor() {
  }

  get isPalaceEnable(){
    return this._isPalaceEnable;
  }

  set isPalaceEnable(value: boolean){
    this._isPalaceEnable = value;
  }
}
